import { render, staticRenderFns } from "./Perishables-Report.vue?vue&type=template&id=054c6d34&"
import script from "./Perishables-Report.vue?vue&type=script&lang=js&"
export * from "./Perishables-Report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports